export enum SidebarTypeEnum {
  customSidebar = 1,
  editInfo = 2,
  customOrder = 3,
  filters = 4,
  shotsComments = 5,
  deleteAction = 6,
  orderComments = 7
}
